"use client";

import React from "react";
import { withCDN, optimizedImage } from "@/src/lib/utils";

export default function ActivitySkeleton() {
  return (
    <>
      <style>{`
        @keyframes shimmer {
          0% {
            background-position: -1000px 0;
          }
          100% {
            background-position: 1000px 0;
          }
        }

        .shimmer {
          background: linear-gradient(
            90deg,
            #e8e8e8 0%,
            #f3f3f3 25%,
            #ffffff 50%,
            #f3f3f3 75%,
            #e8e8e8 100%
          );
          background-size: 1000px 100%;
          animation: shimmer 2s infinite;
        }
      `}</style>

      <section className="relative w-full overflow-hidden bg-transparent z-20 pts-20 mt-[-188px] px-1 md:px-6 lg:px-16 xl:px-32 2xl:px-1">
        {/* Background images */}
        <div className="absolute inset-0 w-full h-[900px] -z-10">
          <img
            src={optimizedImage("https://yefranchisees.b-cdn.net/frontend/additional activities.png", 1920)}
            alt="Additional Activities background"
            className="object-cover object-top hidden lg:block w-full h-full"
          />
          <img
            src={optimizedImage("https://yefranchisees.b-cdn.net/frontend/additional activities.png", 1080)}
            alt="Additional Activities tablet background"
            className="object-cover object-top hidden md:block lg:hidden w-full h-full"
          />
          <img
            src="https://yefranchisees.b-cdn.net/frontend/mobile/additionalactivities-mob.svg"
            alt="Additional Activities mobile background"
            className="object-cover object-top block md:hidden w-full h-full"
          />
        </div>

        <div className="w-full sm:mt-10 pl-5 2xl:pl-35 relative z-10 md:mt-33 mt-33">
          {/* ACTUAL HEADING */}
          <div className="md:text-left mb-2.5 mt-40">
            <h2 className="text-[30px] md:text-[30px] xl:text-[50px] lg:text-[50px] 2xl:text-5xl font-bold text-[#58585A] uppercase tracking-wide">
              Additional Activities
            </h2>
          </div>

          <div className="relative -mr-4 md:-mr-6 lg:-mr-16 xl:-mr-32 2xl:-mr-1 flex flex-row gap-4">
            {/* Left Arrow */}
            <div className="self-center flex transition rounded-full flex-shrink-0 opacity-40 pointer-events-none">
              <img
                src={withCDN("/arrow-left.svg")}
                alt="Next"
                width={28}
                height={28}
                className="object-fit"
              />
            </div>

            {/* Skeleton Cards */}
            <div className="flex gap-4 md:gap-6 lg:gap-4 overflow-x-auto pb-4 md:pb-0 scroll-smooth scrollbar-hide pr-4 md:pr-6 lg:pr-16 xl:pr-32 2xl:pr-1">
              {[1, 2, 3, 4, 5].map((index) => (
                <div
                  key={index}
                  className="flex-shrink-0 w-75 lg:w-[420px] xl:w-[420px] 2xl:w-[420px] bg-white bg-opacity-90 rounded-3xl overflow-hidden transition-shadow flex flex-col"
                >
                  {/* Image skeleton */}
                  <div className="w-full h-40 md:h-[160px] lg:w-[420px] lg:h-[220px] xl:w-[410px] xl:h-[220px] 2xl:w-[420px] 2xl:h-[220px] relative flex-shrink-0 rounded-3xl overflow-hidden bg-gray-200">
                    <div className="w-full h-full shimmer" />
                  </div>

                  {/* Text skeleton */}
                  <div className="pt-4 flex flex-col flex-grow px-4 pb-4">
                    {/* Title skeleton */}
                    <div className="shimmer h-6 w-48 rounded mb-3 bg-gray-200" />

                    {/* Description skeleton */}
                    <div className="flex-grow mb-4 space-y-2">
                      <div className="shimmer h-4 w-full rounded bg-gray-200" />
                      <div className="shimmer h-4 w-5/6 rounded bg-gray-200" />
                      <div className="shimmer h-4 w-4/6 rounded bg-gray-200" />
                    </div>

                    {/* Button skeleton */}
                    <div className="shimmer h-12 w-full rounded-full bg-gray-200" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <style jsx>{`
          .scrollbar-hide {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
          .scrollbar-hide::-webkit-scrollbar {
            display: none;
          }
        `}</style>
      </section>
    </>
  );
}
